module.exports = __webpack_public_path__ + "img/yl.98eff176.jpg";